const STORAGE_KEY = 'productCompare'
const MAX_ITEMS = 4

function normalizeCategoryKey(category) {
    if (!category || typeof category !== 'object') {
        return ''
    }
    if (category.slug) {
        return `slug:${String(category.slug)}`
    }
    if (category.id !== undefined && category.id !== null) {
        return `id:${String(category.id)}`
    }
    const name = category.name || category.title
    return name ? `name:${String(name).trim().toLowerCase()}` : ''
}

export function getCompareList() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        const list = JSON.parse(raw)
        return Array.isArray(list) ? list : []
    } catch (e) {
        return []
    }
}

function persist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
    window.dispatchEvent(new CustomEvent('compare-updated'))
}

/**
 * Знімає з картки каталогу мінімум полів для списку та сторінки порівняння.
 */
export function snapshotFromCardItem(item) {
    if (!item || !item.id || !item.slug) {
        return null
    }
    return {
        id: item.id,
        slug: item.slug,
        title: item.title,
        image: item.image,
        productPrice: item.productPrice,
        productBrand: item.productBrand,
        category: item.category,
        productStatus: item.productStatus
    }
}

export function isInCompareList(productId) {
    const id = String(productId)
    return getCompareList().some((el) => String(el.id) === id)
}

export function addToCompare(snapshot) {
    if (!snapshot) {
        return { ok: false, message: 'Неможливо додати товар' }
    }
    const list = getCompareList()
    if (list.some((el) => String(el.id) === String(snapshot.id))) {
        return { ok: false, reason: 'duplicate' }
    }
    const incomingCategoryKey = normalizeCategoryKey(snapshot.category)
    const sameCategoryCount = list.filter((el) => {
        return normalizeCategoryKey(el.category) === incomingCategoryKey
    }).length
    if (sameCategoryCount >= MAX_ITEMS) {
        return {
            ok: false,
            message: `Можна порівняти не більше ${MAX_ITEMS} товарів в одній категорії. Видаліть один зі списку на сторінці порівняння.`
        }
    }
    list.push(snapshot)
    persist(list)
    return { ok: true, item: snapshot, count: list.length }
}

export function removeFromCompare(productId) {
    const id = String(productId)
    const next = getCompareList().filter((el) => String(el.id) !== id)
    persist(next)
    return next
}

export function clearCompare() {
    persist([])
}

export { MAX_ITEMS as compareMaxItems }
